export default "__VITE_ASSET__e26c2af0__"